import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import unimedLogo from '../../assets/images/logo-unimed-campinas.svg';
import { sxButtonText } from './sxProps';


const LoginWelcome: React.FC = () => {

  const navigate = useNavigate();

  const { textStyleAccessibility, contrastMode } = useAccessibility();

  return (
    <div className='width-100'>
      {
        contrastMode ?
          <h1 style={textStyleAccessibility} className='login-unimed-logo'>Unimed<br />Campinas</h1>
          :
          <img src={unimedLogo} width={'227px'} height={'85px'} alt="Logo Unimed" className='login-unimed-logo' />
      }
      <div className='container-login-painel-left'>
        <span style={textStyleAccessibility} className='login-painel-left-title margin-bottom'>Canal do Cliente</span>
        <span style={textStyleAccessibility} className='login-painel-left-subtitle margin-bottom'>Bem-vindo(a) ao <b>Canal do Cliente</b>!</span>
        <span style={textStyleAccessibility} className='login-text'>Aproveite todos os serviços e funcionalidades </span>
        <span style={textStyleAccessibility} className='login-text'> e facilite seu dia.</span>
        <ul className='padding-horizontal-25'>
          <li style={textStyleAccessibility} className='login-text'>Acesse a 2ª via do boleto</li>
          <li style={textStyleAccessibility} className='login-text'>Visualize suas guias</li>
          <li style={textStyleAccessibility} className='login-text'>Agende uma consulta</li>
          <li style={textStyleAccessibility} className='login-text'>Faça seu atendimento por videochamada</li>
          <li style={textStyleAccessibility} className='login-text'>Acesse atestados digitais</li>
          <li style={textStyleAccessibility} className='login-text'>Confira seu histórico de saúde</li>
        </ul>
        <span style={textStyleAccessibility} className='login-text margin-bottom'>E muito mais!</span>
        <Button
          onClick={() => navigate('/cadastro')}
          endIcon={<FontAwesomeIcon style={{fontSize: '15px'}} icon={faChevronRight} />}
          sx={sxButtonText}
        >
          <Typography style={textStyleAccessibility} sx={sxButtonText}>Cadastrar</Typography>
        </Button>
      </div>
    </div>
  );
};

export default LoginWelcome;
